document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.solucoes-tabs__logos button');
  const tabContents = document.querySelectorAll('.solucao-card');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const index = button.getAttribute('data-tab');

      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(card => card.classList.remove('active'));

      button.classList.add('active');
      document.querySelector(`.solucao-card[data-content="${index}"]`)
        .classList.add('active');
    });
  });

  const accordions = document.querySelectorAll('.accordion-title');

  accordions.forEach(title => {
    title.addEventListener('click', () => {
      const item = title.parentElement;
      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.accordion-item')
        .forEach(i => i.classList.remove('open'));

      if (!isOpen) item.classList.add('open');
    });
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const video = document.getElementById("heroVideo");
  const btn = document.querySelector(".hero-sound-toggle");

  if (!video || !btn) return;

  btn.addEventListener("click", () => {
    video.muted = !video.muted;
    btn.textContent = video.muted ? "🔊" : "🔇";
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.cases-carousel__track');
  const btnNext = document.querySelector('.cases-carousel__arrow.next');
  const btnPrev = document.querySelector('.cases-carousel__arrow.prev');

  if (!track || !btnNext || !btnPrev) return;

  const getStep = () => {
    const card = track.querySelector('.case-card');
    return card ? card.offsetWidth + 16 : 300;
  };

  const smoothScrollTo = (element, target, duration = 400) => {
    const start = element.scrollLeft;
    const change = target - start;
    const startTime = performance.now();

    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

    const animate = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);

      element.scrollLeft = start + change * eased;

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };

  btnNext.addEventListener('click', () => {
    const target = track.scrollLeft + getStep();
    smoothScrollTo(track, target, 600);
  });

  btnPrev.addEventListener('click', () => {
    const target = track.scrollLeft - getStep();
    smoothScrollTo(track, target, 600);
  });

  const updateArrows = () => {
  btnPrev.style.display = track.scrollLeft <= 0 ? 'none' : 'flex';
  btnNext.style.display =
    track.scrollLeft + track.offsetWidth >= track.scrollWidth - 5
      ? 'none'
      : 'flex';
};

track.addEventListener('scroll', updateArrows);
updateArrows();

});
